import { SVGProps, Ref, forwardRef } from 'react';

export const ArchiveboxArrowFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.5 6C.312 6 0 5.688 0 3.5 0 1.313.312 1 2.5 1h19c2.188 0 2.5.313 2.5 2.5 0 2.188-.312 2.5-2.5 2.5zM22 7.8H2v8c.014 2.527.428 4.266 1.424 5.4H9.4c1.58 0 2.8-1.464 2.8-3.15s-1.22-3.15-2.8-3.15H7.443l2.1 2.1-1.273 1.273L3.997 14 8.27 9.727 9.543 11l-2.1 2.1H9.4c2.82 0 4.6 2.536 4.6 4.95 0 2.363-1.705 4.842-4.421 4.947h5.088c5.454 0 7.302-1.803 7.333-7.197v-8"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ArchiveboxArrowFilledSize24Glyph.displayName = 'ArchiveboxArrowFilledSize24Glyph';
